export default __webpack_public_path__ + "static/media/bg-pig.16fb4d92.jpg";